// ---------------------------------------------------------------------------
// Block Definition: header_chips (synthetic internal)
//
// Chrome header field extraction.  Each chip may declare its own pins so
// different chips can pull from different sources.  No visual rendering
// (handled by the main entry point's header chrome logic).
// ---------------------------------------------------------------------------

function nullable(type, description, extra = {}) {
  const t = Array.isArray(type) ? type : [type, "null"];
  return { type: t, ...(description ? { description } : {}), ...extra };
}

const EVIDENCE_DESC = "Verbatim sentence(s) from the SOURCE that justify this value — quote exactly, do not paraphrase.";

export const headerChipsDef = {
  type: "header_chips",
  label: "Header Chips",
  description: "Synthetic block for chrome header field extraction.  Internal only.",

  crystallizer: {
    extractionPhases: ["llm"],

    buildDataSchema(block, opts) {
      const hints = opts.hints || [];
      const ownedKeys = new Set(hints.map(h => h.key).filter(Boolean));
      const chips = (block.chips || []).filter(c => ownedKeys.size === 0 || ownedKeys.has(c.key));
      const props = {};
      for (const c of chips) {
        props[c.key] = nullable("string", c.prompt || c.label || c.key);
      }
      return { type: "object", properties: props, required: Object.keys(props), additionalProperties: false };
    },

    buildShapeDescription(block) {
      return `{ ${(block.chips || []).map(c => `"${c.key}": "<string>"`).join(", ")} }`;
    },

    isBlockLevelTarget() { return false; },
    skipFromPinSchema() { return false; },
    isCodeDerived() { return false; },
    collectHints() { return []; },
    buildPromptSupplement() { return ""; },
    postProcess(data) { return data; },
  },

  renderer: null, // header chips have no standalone visual renderer

  editor: null, // internal only — not surfaced in the block palette
};
